<template>
  <div class="modal-mask">
    <div class="card">
      <div class="left">
        <span class="title">Assign Rider</span>
        <p class="descMsg">Assign rider to appointment # {{ appointmentId }}</p>

        <form>
          <input
            class="form-control"
            placeholder="search rider by name or phone"
            v-model="search"
            @change="onSearchUpdate"
            @input="onSearchUpdate"
          />
        </form>
        <div class="actions">
          <button
            class="btn btn-outline-primary w-100 font-weight-bold"
            @click="$emit('cancel')"
          >
            Cancel
          </button>
          <button
            @click="assignRider"
            class="btn btn-primary w-100 font-weight-bold"
          >
            Assign
          </button>
        </div>
      </div>
      <div class="right">
        <div class="no-data" v-if="filtered && filtered.length <= 0">
          no rider found...
        </div>
        <div
          v-else
          class="rider"
          v-for="rider in filtered"
          v-bind:key="rider.id"
          @click="selectedRider = rider"
        >
          <div class="check-container">
            <div
              class="check"
              v-if="selectedRider && selectedRider.id == rider.id"
            ></div>
          </div>

          <div class="info">
            <span class="name">{{ rider.name }}</span>
            <span class="phone">{{ rider.phone }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var NotificationsController = require("./NotificationsController");
import { HTTP, URLS } from "../network/http";
export default {
  name: "AssignRiderComponent",
  props: ["appointmentId"],
  data() {
    return {
      riders: [],
      filtered: [],
      selectedRider: null,
      search: "",
    };
  },
  methods: {
    onSearchUpdate() {
      console.log("onSearchUpdate");
      console.log(this.search);
      if (!this.search || this.search == "") {
        this.filtered = this.riders;
        return;
      }

      if (!this.search || this.search == "") {
        this.filteredUser = this.users;
        return;
      }
      this.filtered = this.riders.filter((item) => {
        return (
          (item.name &&
            item.name.toLowerCase().includes(this.search.toLowerCase())) ||
          (item.phone && item.phone.includes(this.search))
        );
      });
    },
    getRiders() {
      NotificationsController.showActivityIndicator();

      HTTP.get(URLS.RIDER.LIST)
        .then((response) => {
          this.riders = response.data.rows;
          this.filtered = this.riders;
          console.log(this.riders);
          NotificationsController.hideActivityIndicator();
        })
        .catch((err) => {
          NotificationsController.hideActivityIndicator();
        });
    },
    assignRider() {
      if (!this.selectedRider) {
        this.$toast.danger("Please select a rider");
        return;
      }
      NotificationsController.showActivityIndicator();

      let url = URLS.RIDER.ASSIGN_RIDE;
      console.log(url);
      url = url.replace(":id", this.appointmentId);
      url = url.replace(":riderId", this.selectedRider.id);
      HTTP.patch(url)
        .then((response) => {
          console.log(response);
          NotificationsController.hideActivityIndicator();
          this.$emit("success");
        })
        .catch((error) => {
          console.log(error);
          NotificationsController.hideActivityIndicator();
          this.$toast.error(error.response.data.message || error.message);
        });
    },
  },
  created() {
    this.getRiders();
  },
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;

  .card {
    width: 70%;
    min-height: 50vh;
    max-height: 80vh;
    background-color: white;
    border-radius: 4px;
    padding: 20px;
    display: flex;
    flex-direction: row;
    align-items: stretch !important;

    .left {
      width: 50%;
      display: flex;
      flex-direction: column;

      .title {
        width: 100%;
        line-height: 50px;
        font-size: 20px;
        color: black;
        font-weight: bold;
      }

      .descMsg {
        width: 100%;
        font-size: 14px;
        color: rgb(112, 53, 53);
      }

      .form {
        max-height: calc(100% - 200px);
        width: 100%;
        display: flex;
        flex-direction: column;
        overflow-y: scroll;
      }

      .actions {
        height: 50px;
        width: 100%;
        display: flex;
        flex-direction: row;
        margin-top: auto;
      }
    }

    .right {
      width: 50%;
      margin-left: 2%;
      background: #fafafa;
      overflow-y: scroll;

      .no-data {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
      }

      .rider {
        width: 100%;
        border-bottom: 0.1rem solid #e0e0e0;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 1rem;

        &:hover {
          background: #f5f5f5;
        }

        .check-container {
          width: 1rem;
          height: 1rem;
          border: 0.1rem solid #e0e0e0;
          border-radius: 50%;
          overflow: hidden;

          .check {
            width: 100%;
            height: 100%;
            background: orange;
            border-radius: 50%;
          }
        }

        .info {
          margin-left: 1rem;
          display: flex;
          flex-direction: column;

          .name {
            font-size: 18px;
            color: black;
            font-weight: 600;
          }

          .phone {
            font-size: 14px;
            color: gray;
          }
        }
      }
    }
  }
}
</style>